const MAX_COUNT_SEND_FORGOT_PWD = 5;
const MAX_COUNT_SEND_SIGN_UP = 5;
const ENTERPRISE_PROD_PATH = "https://enterprise.thebarkingdog.tw/";
export { ENTERPRISE_PROD_PATH, MAX_COUNT_SEND_FORGOT_PWD, MAX_COUNT_SEND_SIGN_UP };
